exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".col {\n  background-color: #f7a700;\n  color: white;\n  height: 100vh;\n}\n\n.content {\n  width: 50%;\n  margin: auto;\n}\n\nh2 {\n  padding: 0 6rem;\n  margin: 1.3rem 0;\n}\n\n@media (max-width: 767px) {\n  .content {\n    width: auto;\n  }\n  h2 {\n    padding: 0 2rem;\n  }\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/buildhome/repo/src/app/work/work.component.css
// module id = ../../../../../src/app/work/work.component.css
// module chunks = main